// extracted by mini-css-extract-plugin
module.exports =  {"root":"VdMYmvMRR9_PqbiqE1d3","title":"ThHc7HyGNym1IdVfkmeZ"};